import { type IUpdateDevicePayload } from 'types/payloads/device.payload.types';
import { type DeviceLatestSensorTimestamp } from 'types/device.types';
import BaseAPI from './base.api';

export default class DeviceAPI extends BaseAPI {
  update = async (deviceId: string, payload: IUpdateDevicePayload) => {
    const response = await this.API.patch(`device/${deviceId}`, payload);
    return response.data;
  };

  unassociatedDeviceGetAll = async () => {
    const response = await this.API.get('device/unassociated');
    return response.data;
  };

  deviceLatestSensorDataAll = async (latest?: boolean) => {
    const response = await this.API.get('device/latest-sensor-data', {
      params: {
        latest: latest ?? false,
      },
    });
    return response.data;
  };

  deviceOperationalDataAll = async () => {
    const response = await this.API.get('device/operational-data');
    return response.data;
  };

  latestSensorTimestamps = async (): Promise<DeviceLatestSensorTimestamp[]> => {
    const response = await this.API.get('device/latest-sensor-timestamps');
    return response.data;
  };

  // Full URL for the live-gps-sse stream, built from the same base URL as every
  // other call (BaseAPI's axios baseURL). EventSource can't go through axios, so
  // the caller opens the stream, but the base/customerId still come from here
  // instead of being hardcoded or read from process.env in the component.
  liveGpsSSEUrl = (customerId: string): string => {
    const baseURL = this.axiosInstance.defaults.baseURL ?? '';
    return `${baseURL}device/live-gps-sse?customerId=${customerId}`;
  };
}
